import styled from 'styled-components';
import {
  Radio as SemanticRadio,
} from 'semantic-ui-react';
import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-size: 24px;
`;

export const Description = styled.p`
`;

export const Link = styled.a`
`;

export const ConsentLink = styled(Link)`
  font-weight: 500;
  font-size: 18px;
`;

export const Header = styled.div`
  border-bottom: 1px solid #EFEFEF;
  padding: 10px 55px;
`;

export const Body = styled.div`
  margin: 0px 55px;
`;

export const SubmitButton = styled(ButtonLayoutComponent)`
`;

export const FormsContainer = styled.div`
  margin: 20px 0;
`;

export const FormLine = styled.div`
  display: flex;
`;

export const InputContainer = styled.div`
`;

export const InputLine = styled.div`
  display: flex;
  ${({ marginTop }) => (marginTop && `margin-top: ${marginTop};`)}
  ${({ onClick }) => !!onClick && 'cursor: pointer;'}
`;

export const SubmitContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const RadioInput = styled(SemanticRadio)`
`;

export const InputLabel = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 8px;
`;

export const InputLabelBold = styled(TextLayoutComponent.Bold)`
  margin-right: 5px;
`;
